import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEarthAmericas,
    faThumbsUp,
    faMessage,
    faShare,
    faVolumeXmark,
    faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons';
// Images
import UserIcon from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/user-icon.svg';
import BeforePreviewImage from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/your-image-new.svg';
import LikeIcon from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/like-icon.svg';
import HeartIcon from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/heart-icon.svg';
import StoryPreview from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/story-preview-bg.svg';
import StoryPreviewLogo from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/story-preview-logo.svg';
import StoryArrowUp from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/story-arrow-up.png';
// Import Slick Slider
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FacebookPreview = ({ activeDevice, activeTab, formData }) => {
    const [progress, setProgress] = useState(formData.cards.map(() => 0));

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) =>
                prevProgress.map((cardProgress) => {
                    if (cardProgress >= 100) {
                        return 0;
                    }
                    return cardProgress + 1;
                })
            );
        }, 100);

        return () => clearInterval(interval);
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    return (
        formData.postType === 'Post' ? (
            <div className="max-w-[502px]">
                <div className={`w-full border border-gray-400 rounded-lg pt-5 ${activeDevice === 'mobile' ? 'w-80' : ''}`}>
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col items-start gap-5 px-5">
                            <div className="flex gap-2.5">
                                <img
                                    src={formData.imagePreview || UserIcon}
                                    alt="Preview"
                                    className="w-12 h-12 rounded-full object-cover"
                                />
                                <div className="flex flex-col">
                                    <p className="max-w-[382px] break-words font-semibold text-sm text-gray-900 font-roboto">
                                        {formData.pageInfo || 'Your page here'}
                                    </p>
                                    <div className="flex items-center gap-1">
                                        <p className="font-normal text-xs text-gray-500 font-roboto">
                                            {activeTab === 'organic' ? '3h ' : 'Sponsored '}<span>.</span>
                                        </p>
                                        <FontAwesomeIcon
                                            icon={faEarthAmericas}
                                            className="w-3 h-3 text-gray-500"
                                        />
                                    </div>
                                </div>
                            </div>
                            <p className="text-sm text-gray-900 font-roboto">
                                {formData.message || 'Your message here'}
                            </p>
                        </div>

                        <div className="relative w-full">
                            {formData.cards.map((card, index) => (
                                <React.Fragment key={card.id}>
                                    <img
                                        className={`w-full object-cover ${index > 0 ? 'max-w-40 h-40 mr-2.5' : ''}`}
                                        src={card.image || BeforePreviewImage}
                                        alt={`Card ${index + 1}`}
                                    />
                                    {index === 4 && (
                                        <div className="absolute right-0 bottom-1.5 w-40 z-50 h-40 bg-red-500 flex content-center justify-center flex-wrap">
                                            <div className="text-white">+ {formData.cards.length - 4}</div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        <div className="flex flex-col gap-5 px-5 pb-5">
                            {activeTab === 'organic' ? (
                                <div className="flex justify-between items-center">
                                    <div className="flex gap-1.5">
                                        <div className="flex items-center">
                                            <img src={LikeIcon} alt="Like Icon" className="w-4.5 h-4.5" />
                                            <img
                                                src={HeartIcon}
                                                alt="Heart Icon"
                                                className="w-4.5 h-4.5 -ml-1"
                                            />
                                        </div>
                                        <p className="font-bold text-sm text-gray-400 font-nunito-sans">0</p>
                                    </div>
                                    <div className="flex gap-5">
                                        <p className="font-bold text-sm text-gray-400 font-nunito-sans">0 Comments</p>
                                        <p className="font-bold text-sm text-gray-400 font-nunito-sans">0</p>
                                    </div>
                                </div>
                            ) : (
                                formData.cards.map((card) => (
                                    <div key={card.id} className="py-4 px-5 bg-gray-50">
                                        <div className="flex flex-col gap-1">
                                            <span className="text-sm leading-4 text-gray-600 font-roboto">
                                                {card.displayLink || 'Your display link'}
                                            </span>
                                            <h5 className="text-lg leading-5 font-bold font-roboto">
                                                {card.headline || 'Your headline here'}
                                            </h5>
                                            <p className="font-normal text-sm leading-4.5 text-gray-600 font-roboto">
                                                {card.description || 'Your description here'}
                                            </p>
                                        </div>
                                        <div className="mt-2.5">
                                            <a
                                                href={card.urlLandingPage || '#'}
                                                className="px-3 py-2 rounded bg-gray-200 font-semibold text-sm leading-5 text-gray-900 font-roboto"
                                            >
                                                {card.callToAction || 'Your call to action'}
                                            </a>
                                        </div>
                                    </div>
                                ))
                            )}
                            <div className="w-full flex items-center justify-evenly">
                                <div className="w-1/3 flex items-center gap-1.5 justify-center">
                                    <FontAwesomeIcon
                                        icon={faThumbsUp}
                                        className="text-sm font-bold text-gray-500 font-nunito-sans"
                                    />
                                    <p className="text-sm font-bold text-gray-500 font-nunito-sans">Like</p>
                                </div>
                                <div className="w-1/3 flex items-center gap-1.5 justify-center">
                                    <FontAwesomeIcon
                                        icon={faMessage}
                                        className="text-sm font-bold text-gray-500 font-nunito-sans"
                                    />
                                    <p className="text-sm font-bold text-gray-500 font-nunito-sans">Comment</p>
                                </div>
                                <div className="w-1/3 flex items-center gap-1.5 justify-center">
                                    <FontAwesomeIcon
                                        icon={faShare}
                                        className="text-sm font-bold text-gray-500 font-nunito-sans"
                                    />
                                    <p className="text-sm font-bold text-gray-500 font-nunito-sans">Share</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : formData.postType === 'Story' ? (
            <div className="max-w-[502px]">
                {formData.cards.map((card, index) => (
                    <div
                        key={card.id}
                        className="w-80 h-[567px] relative bg-cover bg-center bg-no-repeat"
                        style={{ backgroundImage: `url(${card.image || StoryPreview})` }}
                    >
                        <div className="absolute right-5 left-5 top-5 flex flex-col justify-between items-start gap-2.5">
                            <div className="w-full h-0.75 rounded-l bg-white/60">
                                <div
                                    className="h-full bg-white transition-all duration-100 ease-linear"
                                    style={{ width: `${progress[index]}%` }}
                                ></div>
                            </div>
                            <div className="w-full flex justify-between items-start">
                                <div className="flex gap-2.5 items-start">
                                    <img
                                        src={formData.imagePreview || StoryPreviewLogo}
                                        alt="Story Preview Logo"
                                        className="w-8.5 h-8.5 rounded-full"
                                    />
                                    <div className="flex flex-col">
                                        <p className="text-xs text-white font-roboto">
                                            {formData.pageInfo || 'Your page here'}
                                        </p>
                                        <div className="flex items-center">
                                            <p className="font-normal text-xs text-white/60 font-roboto">
                                                {activeTab === 'organic' ? ' ' : 'Sponsored '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-5 self-center">
                                    <FontAwesomeIcon icon={faVolumeXmark} />
                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                </div>
                            </div>
                        </div>
                        {activeTab === 'paid' && (
                            <div className="absolute bottom-5 right-0 left-0 flex items-center justify-center">
                                <div className="flex flex-col items-center gap-0">
                                    <img src={StoryArrowUp} alt="Story Arrow Up" />
                                    <a
                                        href={card.urlLandingPage || '#'}
                                        className="px-5 py-1.5 bg-white rounded-full text-black font-bold text-xs font-helvetica"
                                    >
                                        {card.callToAction || 'Your call to action'}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        ) : formData.postType === 'Story Carousel' ? (
            <div className="max-w-[502px]">
                <Slider {...settings}>
                    {formData.cards.map((card, index) => (
                        <div key={card.id}>
                            <div
                                className="w-80 h-[567px] relative bg-cover bg-center bg-no-repeat"
                                style={{ backgroundImage: `url(${card.image || '/story-preview-bg.svg'})` }}
                            >
                                <div className="absolute right-5 left-5 top-5 flex flex-col justify-between items-start gap-2.5">
                                    <div className="w-full h-0.75 rounded-l bg-white/60">
                                        <div
                                            className="h-full bg-white transition-all duration-100 ease-linear"
                                            style={{ width: `${progress[index]}%` }}
                                        ></div>
                                    </div>
                                    <div className="w-full flex justify-between items-start">
                                        <div className="flex gap-2.5 items-start">
                                            <img
                                                src={formData.imagePreview || '/story-preview-logo.svg'}
                                                alt="Story Preview Logo"
                                                className="w-8.5 h-8.5 rounded-full"
                                            />
                                            <div className="flex flex-col">
                                                <p className="text-xs text-white font-roboto">
                                                    {formData.pageInfo || 'Your page here'}
                                                </p>
                                                <div className="flex items-center">
                                                    <p className="font-normal text-xs text-white/60 font-roboto">
                                                        {activeTab === 'organic' ? ' ' : 'Sponsored '}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex gap-5 self-center">
                                            <FontAwesomeIcon icon={faVolumeXmark} />
                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                        </div>
                                    </div>
                                </div>
                                {activeTab === 'paid' && (
                                    <div className="absolute bottom-5 right-0 left-0 flex items-center justify-center">
                                        <div className="flex flex-col items-center gap-0">
                                            <img src="/story-arrow-up.png" alt="Story Arrow Up" />
                                            <a
                                                href={card.urlLandingPage || '#'}
                                                className="px-5 py-1.5 bg-white rounded-full text-black font-bold text-xs font-helvetica"
                                            >
                                                {card.callToAction || 'Your call to action'}
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        ) : null
    );
};

export default FacebookPreview;